import React from 'react';
//import img from '../_assets/_image/error.png';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }
  
  
  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    
    return this.setState({
      error: error,
      errorInfo: errorInfo
    })
    // You can also log error messages to an error reporting service here
  }
  
  render() {
    
    if (this.state.error !== null) {
      // Error path
      return (
        <div>
          <div className="body-large grey-text u-center-text u-margin-top-xsmall">Oops, something went wrong! Please refresh the page and try again.</div>
          {/* <details style={{ whiteSpace: 'pre-wrap' }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo.componentStack}
          </details> */}
        </div>
      );
      
  } 
  return this.props.children; 
  
}
  
}
//const page = ErrorBoundary;
//export  { page as ErrorBoundary }